import { useEffect, useState } from "react";
import {
  listOrganizationMembers,
  type OrganizationMemberRecord,
} from "@/lib/organization-client";

export function useOrganizationMembers() {
  const [data, setData] = useState<OrganizationMemberRecord[] | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    async function loadMembers() {
      setIsLoading(true);
      setError(null);

      try {
        const members = await listOrganizationMembers();
        if (!cancelled) {
          setData(members);
        }
      } catch (err) {
        if (!cancelled) {
          setData(null);
          setError(err instanceof Error ? err.message : "Failed to load organization members");
        }
      } finally {
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    }

    void loadMembers();

    return () => {
      cancelled = true;
    };
  }, []);

  return { data, isLoading, error };
}
